<template>
  <div>
    <div
      class="flex flex-wrap mb-12 items-start gap-4 theme-white"
    >
      <search-input
        :placement="placement"
        class="max-w-full md:flex-400"
      />
      <button
        class="btn solid min-w-160 flex justify-between w-full md:w-auto px-4 py-2 font-light"
        @click="onFilterOpenButtonClick"
      >
        {{ filtersLabel }}
        <IconFilter
          class="icon fill-current my-auto ml-4"
          width="16px"
        />
      </button>
      <products-selected-filters
        :placement="placement"
        class="gap-3"
      />
      <div
        class="facet-tag-menu fixed left-0 top-0 w-full h-full z-40 flex"
        :class="{ 'is-opened': showFilterOverlay, 'is-closing': filtersOverlayIsAnimating }"
      >
        <div class="relative flex-1 w-full">
          <div
            class="facet-tag-menu__overlay absolute left-0 top-0 w-full h-full js-facet-tag-menu__overlay"
            @click="closeFilters"
          />
          <div class="facet-tag-menu__content relative w-full h-full md:max-w-400 flex flex-col flex-shrink-0">
            <div class="bg-blue-dark px-4 py-4 md:py-6">
              <div class="flex flex-shrink-0 justify-end md:mt-3 mb-3">
                <span
                  role="button"
                  @click="onCloseFiltersClick"
                >
                  <IconCross
                    width="20px"
                    height="20px"
                    stroke="white"
                  />
                </span>
              </div>
              <h4 class="text-white text-2xl font-bold">
                {{ filtersTitle }}
              </h4>
            </div>
            <div
              ref="refFilters"
              class="bg-white flex-1 overflow-auto c-facet-tag-menu__accordion"
            >
              <search-category-group
                v-for="(group, index) in categories"
                :key="group.slug"
                :model="group"
                :placement="placement"
                :index="index"
                class="px-6 relative border-t border-black border-opacity-20"
                @changeCategory="closeFilters"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import SearchInput from '@/components/search/SearchInput.vue'
import SearchCategoryGroup from '@/components/search/SearchCategoryGroup.vue'
import IconFilter from '@/assets/icons/filter.svg'
import IconCross from '@/assets/icons/icon-cross.svg'
import searchConfig from '@/compositions/search/SearchConfiguration'
import ProductsSelectedFilters from '@/components/products/ProductsSelectedFilters.vue'
import tracking from '@/helpers/tracking'

export default {
  components: {
    ProductsSelectedFilters,
    SearchCategoryGroup,
    IconCross,
    IconFilter,
    SearchInput
  },
  setup() {
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const placement = 'Product overview'

    const showFilterOverlay = ref(false)
    const filtersOverlayIsAnimating = ref(false)
    const refFilters = ref(null)

    const onFilterOpenButtonClick = () => {
      tracking.openFilterMenu({
        placement
      })
      showFilterOverlay.value = true
      disableBodyScroll(refFilters.value)
    }

    const closeFilters = () => {
      filtersOverlayIsAnimating.value = true
      setTimeout(() => {
        showFilterOverlay.value = false
        filtersOverlayIsAnimating.value = false
        enableBodyScroll(refFilters.value)
      }, 300)
    }

    const onCloseFiltersClick = () => {
      tracking.closeFilterMenu({
        placement
      })
      closeFilters()
    }

    return {
      refFilters,
      categories: computed(() => getActiveConfig().categories),
      filtersLabel: computed(() => getActiveConfig().translations.filtersLabel),
      filtersTitle: computed(() => getActiveConfig().translations.filtersTitle),
      filtersOverlayIsAnimating,
      showFilterOverlay,
      placement,

      closeFilters,
      onCloseFiltersClick,
      onFilterOpenButtonClick
    }
  }
}
</script>
